module.exports = __webpack_public_path__ + "static/media/previdencia.1318bc13.svg";